import { RetailerApiClient } from '@/services/RetailerApiClient.js'

export default {
  getDashboard(params) {
    return RetailerApiClient.get('dashboard', { params })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getDashboardMenuItemsBadgeCount() {
    return RetailerApiClient.get('dashboard/menu-items-badge-count')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getLastOrders() {
    return RetailerApiClient.get('dashboard/last-orders')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getSeasonInfo() {
    return RetailerApiClient.get('dashboard/season-info')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getRanking(params) {
    return RetailerApiClient.get('dashboard/ranking', { params })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
